<!--
  - This Application Was Designed, Developed & Maintained with {❤️ + ☕️} by Eng. Golden. T. Chimusinde. Copyright (c) 2020.
  -->

<template>
    <div class="row justify-content-center">
        <div id="demo" class="carousel slide" data-ride="carousel">
            <!-- Indicators -->
            <ol class="carousel-indicators">
                <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
                <li data-target="#myCarousel" data-slide-to="1"></li>
                <li data-target="#myCarousel" data-slide-to="2"></li>
            </ol>

            <!-- Wrapper for slides -->
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img
                        src="https://ownai.co.zw/tickets/wp-content/uploads/2020/02/banner-1.png"
                        alt="Category: A"
                        style="width:100%;">
                </div>

                <div class="carousel-item">
                    <img
                        src="https://ownai.co.zw/tickets/wp-content/uploads/2020/02/banner-2.png"
                        alt="Category: B"
                        style="width:100%;">
                </div>

                <div class="carousel-item">
                    <img src="https://ownai.co.zw/tickets/wp-content/uploads/2020/02/banner-3.png"
                         alt="Category: C"
                         style="width:100%;">
                </div>
            </div>

            <!-- Left and right controls -->
            <a class="carousel-control-prev" href="#demo" data-slide="prev">
                <span class="carousel-control-prev-icon"></span>
            </a>
            <a class="carousel-control-next" href="#demo" data-slide="next">
                <span class="carousel-control-next-icon"></span>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('SlideShowComponent mounted.')
        }
    }
</script>
